(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tab"] && !Shopify.designMode) return;
  try {
    (function() {
    if (customElements.get('tabs-block')) return;

    class TabsBlock extends HTMLElement {
      connectedCallback() {
        setTimeout(() => this.init(), 50);

        document.addEventListener('shopify:block:select', (e) => {
          if (e.target === this) this.activate();
        });

        if (this.dataset.enableGalleryPopup !== 'false') {
          this.initLightbox();
        }

        if (this.dataset.disableDesktopTab === 'true') {
          window.addEventListener('resize', () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => this.handleResize(), 200);
          });
        }
      }

      initLightbox() {
        if (window.tabsLightboxInitialized) return;
        window.tabsLightboxInitialized = true;

        const lightbox = document.createElement('div');
        lightbox.className = 'tabs-lightbox';
        lightbox.innerHTML = `
          <button class="tabs-lightbox__close" aria-label="Close">&times;</button>
          <button class="tabs-lightbox__nav tabs-lightbox__nav--prev" aria-label="Previous"></button>
          <button class="tabs-lightbox__nav tabs-lightbox__nav--next" aria-label="Next"></button>
          <div class="tabs-lightbox__content">
            <img class="tabs-lightbox__img" src="" alt="">
          </div>
        `;
        document.body.appendChild(lightbox);

        let currentImages = [];
        let currentIndex = 0;

        const updateLightboxImage = (index) => {
          if (index < 0) index = currentImages.length - 1;
          if (index >= currentImages.length) index = 0;
          currentIndex = index;
          
          const img = currentImages[currentIndex];
          const lightboxImg = lightbox.querySelector('.tabs-lightbox__img');
          lightboxImg.style.opacity = '0';
          
          setTimeout(() => {
            lightboxImg.src = img.currentSrc || img.src;
            lightboxImg.alt = img.alt || '';
            lightboxImg.style.opacity = '1';
          }, 150);
        };

        const closeLightbox = () => {
          lightbox.classList.remove('active');
          document.body.classList.remove('lightbox-open');
          setTimeout(() => { lightbox.style.display = 'none'; }, 300);
        };

        lightbox.addEventListener('click', (e) => {
          if (e.target.closest('.tabs-lightbox__nav--prev')) {
            updateLightboxImage(currentIndex - 1);
          } else if (e.target.closest('.tabs-lightbox__nav--next')) {
            updateLightboxImage(currentIndex + 1);
          } else if (e.target.closest('.tabs-lightbox__close')) {
            closeLightbox();
          } else if (!e.target.closest('.tabs-lightbox__img')) {
            closeLightbox();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (!lightbox.classList.contains('active')) return;
          
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') updateLightboxImage(currentIndex - 1);
          if (e.key === 'ArrowRight') updateLightboxImage(currentIndex + 1);
        });

        document.addEventListener('click', (e) => {
          const img = e.target.closest('.tabs-block__panel img');
          if (img) {
            const panel = img.closest('.tabs-block__panel');
            currentImages = Array.from(panel.querySelectorAll('img'));
            currentIndex = currentImages.indexOf(img);
            
            updateLightboxImage(currentIndex);
            
            lightbox.style.display = 'flex';
            setTimeout(() => {
              lightbox.classList.add('active');
              document.body.classList.add('lightbox-open');
            }, 10);
          }
        });
      }

      init() {
        const groupId = this.dataset.tabsParent;
        if (!groupId) return;

        if (this.dataset.disableDesktopTab === 'true' && window.innerWidth >= 992) return;

        const section = this.closest('.shopify-section, [id^="shopify-section-"]');
        if (!section) return;

        const tabs = section.querySelectorAll(`tabs-block[data-tabs-parent="${groupId}"]`);
        if (tabs[0] !== this) return;

        this.setupGroup(section, tabs, groupId);
      }

      setupGroup(section, tabs, groupId) {
        const allTabSettings = Array.from(tabs).find((tab) => tab.dataset.showAllTab === 'true');
        const hasAllTab = Boolean(allTabSettings);
        const allTabLabel = allTabSettings?.dataset.allTabLabel || 'All';
        let tabList = section.querySelector(`.tabs-blocks-container[data-group="${groupId}"]`);
        if (!tabList) {
          tabList = document.createElement('div');
          tabList.className = 'tabs-blocks-container';
          tabList.dataset.group = groupId;
          tabList.setAttribute('role', 'tablist');

          const firstWrap = tabs[0].closest('.shopify-block') || tabs[0];
          firstWrap.parentNode.insertBefore(tabList, firstWrap);
        } else {
          tabList.innerHTML = '';
        }

        const tabIndexes = Array.from(tabs, (_tab, index) => index);
        const orderedTriggers = hasAllTab ? ['all', ...tabIndexes] : tabIndexes;

        if (hasAllTab) {
          const allTrigger = this.createAllTrigger(allTabLabel);
          tabList.appendChild(allTrigger);

          allTrigger.addEventListener('click', () => {
            this.activateGroupTab(tabs, 'all', tabList);
          });

          allTrigger.addEventListener('keydown', (e) => {
            this.handleTriggerKeydown(e, orderedTriggers, 0, tabs, tabList);
          });

          const allPanel = document.createElement('div');
          allPanel.className = 'tabs-block__panel tabs-block__panel--all';
          allPanel.setAttribute('role', 'tabpanel');
          allPanel.id = `tabs-all-panel-${groupId}`;
          allPanel.dataset.group = groupId;
          allPanel.setAttribute('hidden', '');

          const firstWrap = tabs[0].closest('.shopify-block') || tabs[0];
          firstWrap.parentNode.insertBefore(allPanel, firstWrap);
        }

        tabIndexes.forEach((index) => {
          const triggerPosition = orderedTriggers.indexOf(index);
          const tab = tabs[index];
          const originalTrigger = tab.querySelector('.tabs-block__trigger');
          if (!originalTrigger) return;

          const trigger = originalTrigger.cloneNode(true);
          trigger.classList.add('is-visible');
          trigger.dataset.tabIndex = index;
          tabList.appendChild(trigger);

          trigger.addEventListener('click', () => {
            this.activateGroupTab(tabs, index, tabList);
          });

          trigger.addEventListener('keydown', (e) => {
            this.handleTriggerKeydown(e, orderedTriggers, triggerPosition, tabs, tabList);
          });
        });

        this.activateGroupTab(tabs, hasAllTab ? 'all' : tabIndexes[0], tabList);
      }

      createAllTrigger(label) {
        const trigger = document.createElement('button');
        trigger.className = 'tabs-block__trigger tabs-block__trigger--all is-visible';
        trigger.type = 'button';
        trigger.role = 'tab';
        trigger.dataset.allTabsTrigger = 'true';
        trigger.setAttribute('aria-selected', 'false');
        trigger.innerHTML = '<span class="tabs-block__trigger-text"></span>';
        trigger.querySelector('.tabs-block__trigger-text').textContent = label;
        return trigger;
      }

      handleTriggerKeydown(e, orderedTriggers, currentPosition, tabs, tabList) {
        let nextPosition;
        if (e.key === 'ArrowRight') nextPosition = (currentPosition + 1) % orderedTriggers.length;
        else if (e.key === 'ArrowLeft') nextPosition = (currentPosition - 1 + orderedTriggers.length) % orderedTriggers.length;
        else return;

        e.preventDefault();

        const nextTrigger = orderedTriggers[nextPosition];
        this.activateGroupTab(tabs, nextTrigger, tabList);
        tabList.querySelectorAll('.tabs-block__trigger')[nextPosition]?.focus();
      }

      activateGroupTab(tabs, activeIndex, tabList) {
        const isAllActive = activeIndex === 'all';
        const allTrigger = tabList.querySelector('[data-all-tabs-trigger="true"]');
        const groupId = tabs[0]?.dataset.tabsParent;
        const allPanel = groupId ? document.getElementById(`tabs-all-panel-${groupId}`) : null;

        if (isAllActive && allPanel) {
          const allContent = document.createElement('div');
          allContent.className = 'tabs-block__panel-content';

          tabs.forEach((tab) => {
            const panelContent = tab.querySelector('.tabs-block__panel-content');
            if (panelContent) {
              Array.from(panelContent.children).forEach(child => {
                allContent.appendChild(child.cloneNode(true));
              });
            }
          });

          allPanel.innerHTML = '';
          allPanel.appendChild(allContent);
          allPanel.removeAttribute('hidden');
        } else if (allPanel) {
          allPanel.innerHTML = '';
          allPanel.setAttribute('hidden', '');
        }

        tabs.forEach((tab, index) => {
          const isActive = isAllActive || index === activeIndex;
          const isActiveTab = !isAllActive && index === activeIndex;
          const trigger = tabList.querySelector(`.tabs-block__trigger[data-tab-index="${index}"]`);
          const blockWrapper = tab.closest('.shopify-block') || tab;

          if (isAllActive) {
            blockWrapper.setAttribute('hidden', '');
            tab.classList.remove('active');
          } else if (isActive) {
            blockWrapper.removeAttribute('hidden');
            tab.classList.add('active');
          } else {
            blockWrapper.setAttribute('hidden', '');
            tab.classList.remove('active');
          }

          if (trigger) {
            trigger.classList.toggle('active', isActiveTab);
            trigger.setAttribute('aria-selected', isActiveTab ? 'true' : 'false');
            trigger.tabIndex = isActiveTab ? 0 : -1;
            
            //if (isActiveTab) {
              //trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            //}
          }
        });

        if (allTrigger) {
          allTrigger.classList.toggle('active', isAllActive);
          allTrigger.setAttribute('aria-selected', isAllActive ? 'true' : 'false');
          allTrigger.tabIndex = isAllActive ? 0 : -1;

          // if (isAllActive) {
          //   allTrigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          // }
        }
      }

      activate() {
        const groupId = this.dataset.tabsParent;
        const section = this.closest('.shopify-section, [id^="shopify-section-"]');
        const tabList = section?.querySelector(`.tabs-blocks-container[data-group="${groupId}"]`);
        const tabs = Array.from(section?.querySelectorAll(`tabs-block[data-tabs-parent="${groupId}"]`) || []);
        const index = tabs.indexOf(this);

        if (index !== -1 && tabList) {
          this.activateGroupTab(tabs, index, tabList);
        }
      }

      handleResize() {
        const groupId = this.dataset.tabsParent;
        if (!groupId) return;

        const section = this.closest('.shopify-section, [id^="shopify-section-"]');
        if (!section) return;

        const tabs = Array.from(section.querySelectorAll(`tabs-block[data-tabs-parent="${groupId}"]`));
        if (tabs[0] !== this) return;

        const isDesktop = window.innerWidth >= 992;

        if (isDesktop) {
          this.teardownGroup(section, tabs, groupId);
        } else if (!section.querySelector(`.tabs-blocks-container[data-group="${groupId}"]`)) {
          this.setupGroup(section, tabs, groupId);
        }
      }

      teardownGroup(section, tabs, groupId) {
        const tabList = section.querySelector(`.tabs-blocks-container[data-group="${groupId}"]`);
        if (tabList) tabList.remove();

        const allPanel = document.getElementById(`tabs-all-panel-${groupId}`);
        if (allPanel) allPanel.remove();

        tabs.forEach((tab) => {
          const blockWrapper = tab.closest('.shopify-block') || tab;
          blockWrapper.removeAttribute('hidden');
          tab.classList.remove('active');
        });
      }
    }

    customElements.define('tabs-block', TabsBlock);
  })();
  } catch(e) { console.error(e); }
})();

})();
